import { buildUrl } from "source/shared/buildUrl"
import { useInfiniteLoadingResource } from "source/shared/useInfiniteLoadingResource"

const DEFAULT_PARAMS = { order: "sequence", include: "options", per_page: 25 }

export function useFormFields({ formId }) {
  const url = buildFormFieldsUrl(formId)
  const {
    records: formFields,
    included: formFieldOptions,
    ...rest
  } = useInfiniteLoadingResource(url)
  return { formFields, formFieldOptions, ...rest }
}

function buildFormFieldsUrl(formId) {
  return buildUrl(`/calendar/v2/forms/${formId}/fields`, DEFAULT_PARAMS)
}
